import { render } from "./ComisionesComisiones.vue?vue&type=template&id=cfe425e0&scoped=true"
import script from "./ComisionesComisiones.vue?vue&type=script&lang=ts"
export * from "./ComisionesComisiones.vue?vue&type=script&lang=ts"

import "./ComisionesComisiones.vue?vue&type=style&index=0&id=cfe425e0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cfe425e0"

export default script